import React from 'react';

const toneStyles = {
  primary: 'bg-blue-600 hover:bg-blue-700',
  danger: 'bg-red-600 hover:bg-red-700',
  warning: 'bg-amber-500 hover:bg-amber-600',
  neutral: 'bg-gray-800 hover:bg-gray-900',
};

const ConfirmModal = ({
  isOpen,
  title = 'Confirmar',
  message = '',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  tone = 'primary',
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;
  const confirmClass = toneStyles[tone] || toneStyles.primary;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[1200] flex items-center justify-center p-4"
      onClick={(e) => {
        e.stopPropagation();
        onCancel?.();
      }}
    >
      <div
        className="bg-white w-full max-w-md rounded-lg shadow-lg p-5 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onCancel}
          className="absolute top-2 right-2 text-gray-600 hover:text-black bg-white p-1 rounded-full"
          aria-label="Cerrar"
        >
          ✕
        </button>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        {message ? (
          <p className="text-sm text-gray-600 mt-2">{message}</p>
        ) : null}
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm rounded border border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-4 py-2 text-sm rounded text-white ${confirmClass}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
